import type { SEOHandle } from "@nasa-gcn/remix-seo";
import type { MetaFunction } from "@remix-run/node";

import PricingTiers from "~/components/pricing/PricingTiers";
import CtaBanner from "~/components/sections/CtaBanner";
import Faq from "~/components/sections/Faq";
import { CURRENT_OFFER } from "~/config/constants";
import generateSitemapEntriesFor from "~/helpers/sitemapEntriesWithLocal";
import common from "~/i18n/common";
import faqDict from "~/i18n/faq";
import pages from "~/i18n/pages";
import { useT } from "~/i18n/useT";
import { buildMeta, langFromParams } from "~/seo/meta";
import { breadcrumbSchema, faqSchema } from "~/seo/schema";

import "./pricing.scss";

export const meta: MetaFunction = ({ params }) => {
  const lang = langFromParams(params);
  const t = pages[lang].pricingPage;

  return [
    ...buildMeta({
      lang,
      path: "/pricing",
      title: t.metaTitle,
      description: t.metaDescription,
    }),
    { "script:ld+json": faqSchema(faqDict[lang].items) },
    {
      "script:ld+json": breadcrumbSchema(lang, [
        { name: common[lang].a11y.home, path: "/" },
        { name: common[lang].nav.pricing, path: "/pricing" },
      ]),
    },
  ];
};

export const handle: SEOHandle = generateSitemapEntriesFor(
  "/pricing",
  undefined,
  "weekly",
  0.9,
);

export default function PricingPage() {
  const t = useT(pages).pricingPage;
  const c = useT(common);

  return (
    <main id="main-content">
      <section className="ss-container ss-pricing-hero">
        <p className="ss-pricing-hero__offer">{t.offerBadge(CURRENT_OFFER)}</p>
        <h1 className="ss-pricing-hero__title">{t.title}</h1>
        <p className="ss-pricing-hero__lead">{t.lead}</p>
      </section>

      <section className="ss-section--tight ss-container">
        <PricingTiers />
      </section>

      <Faq />

      <CtaBanner
        title={t.cta.title}
        body={t.cta.body}
        action={c.cta.scheduleConsultation}
      />
    </main>
  );
}
